const routes = [
    {
        path: '/cte/conhecimentos',
        alias: ['/cte/conhecimentos/index'],
        component: () => import('../views/Listar')
    },
    {
        path: '/cte/conhecimentos/adicionar',
        component: () => import('../views/Adicionar')
    },
    {
        path: '/cte/conhecimentos/editar/:id',
        component: () => import('../views/Editar')
    },
    {
        path: '/cte/conhecimentos/visualizar/:id',
        component: () => import('../views/Visualizar')
    },
    {
        name: 'importarXml',
        path: '/cte/conhecimentos/importar-xml',
        component: () => import('../views/ImportarXml')
    }
]

export default routes